/**
 * 用于存放当前环境及设备版本
 * */
const UA = window.navigator.userAgent;

interface ICurENVandDEV {
  [propName: string]: boolean;
}

/**
 * 自执行函数，获取当前宿主环境
 * 用法 curEnv.isSYHAPP: boolean
 * */
export const curEnv: ICurENVandDEV = ((ua) => {
  {
    return {
      isSYHAPP: /SIMS/i.test(ua),
      isAYHAPP: /MSXFAYH/i.test(ua),
      isMSJRAPP: /msxf/.test(ua),
      isAPP: /SIMS/i.test(ua),
      isWeChat: /MicroMessenger/.test(ua),
      isAliMini: /AliApp/i.test(ua),
      isAlipay: /AlipayClient/i.test(ua),
      // isAlipay: true,
      isChrome: /chrome/i.test(ua),
      isSafari: /safari/.test(ua),
      isQQ: /(QQ)/i.test(ua),
      pc: !/(Android|iPhone|iPod|iOS|SymbianOS|Windows Phone)/i.test(ua),
      isWeChatMiniProgram: /(MicroMessenger)/i.test(ua) && /miniProgram/i.test(ua),
      android: /(Android|Linux)/i.test(ua),
      isTencentSeries: /(MicroMessenger)/i.test(ua) || /(QQ)/i.test(ua),
      isAliSeries: /AliApp/.test(ua) || /(AlipayClient)/i.test(ua),
      //百度小程序
      isBaiduMiniApp:
        ua.toLowerCase().indexOf('baiduboxapp/') !== -1 ||
        ua.toLowerCase().indexOf('smartapp-baidu/') !== -1,
      //快手小程序
      isKuaishouMiniApp:
        ua.toLowerCase().indexOf('miniprogram/') !== -1 &&
        ua.toLowerCase().indexOf('kwapp/') !== -1,
      //快应用
      isKyy:
        ua.indexOf('com.msxf.msjr') > -1 ||
        ua.indexOf('com.msxf.ayh') > -1 ||
        ua.indexOf('quick_app_st_channel') > -1 ||
        ua.indexOf('kyy') > -1,
      //抖音小程序
      isDouyinMiniApp: ua.toLowerCase().indexOf('toutiaomicroapp') > -1,
    };
  }
})(UA);

export function onPageShowHide(callback) {
  // 设置隐藏属性和改变可见属性的事件的名称
  let hidden, visibilityChange;
  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
  } else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
  } else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  }

  // 如果页面是隐藏状态，则暂停视频
  // 如果页面是展示状态，则播放视频
  function handleVisibilityChange() {
    if (typeof callback === 'function') {
      callback(document[hidden]);
    }
  }

  // 如果浏览器不支持addEventListener 或 Page Visibility API 给出警告
  if (typeof document.addEventListener === 'undefined' || typeof document[hidden] === 'undefined') {
    console.log(
      'This demo requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API.',
    );
  } else {
    // 处理页面可见属性的改变
    document.addEventListener(visibilityChange, handleVisibilityChange, false);
  }
}

// 获取当前设备(断言版)
export const curDev: ICurENVandDEV = ((ua) => ({
  isIOS: /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(ua),
  isAndroid: /Android|Adr/.test(ua),
  isHarmony: /Harmony/i.test(ua),
  isPureHarmonyOS: /Harmony/i.test(ua) && !/Android|Adr/.test(ua), //纯血鸿蒙
  isWindow: /IEMobile/i.test(ua),
}))(UA);

/**返回当前系统类型*/
export const mobileOS: string = ((ua) => {
  if (/Android/i.test(ua)) {
    return 'ANDROID';
  }
  if (/iPhone|iPad|iPod/i.test(ua)) {
    return 'IOS';
  }
  if (/OpenHarmony/i.test(ua)) {
    return 'HARMONY';
  }
  if (/IEMobile/i.test(ua)) {
    return 'WINDOW';
  }
  return 'OTHERS';
})(UA);

/** 本地环境 */
export const isLocalEnv = () => {
  // 设置了dev变量 则为dev
  const isDev = !!window?._isMsLocalEnv || false;
  return isDev || location.hostname === 'localhost';
};

export const isStageFsim = function () {
  return /apigateway-fsim\.xiaolongcloud\.local$/.test(location.hostname);
};

export const isRealOnline = function () {
  return process.env.IS_PRODUCTION && location.host.includes('xiaolongcloud.com');
};
